import {defineStore} from "pinia";
import {ref} from "vue";
import commonJs from "@/plugins/commonJs";
import _ from "lodash"
import moment from "moment";

const CLAIM_PROGRESS_INIT_DATA = (startStep = 1, endStep = 5) => {
    return {
        claimProgressCurrentStep: startStep,
        claimProgressTotalStep: _.range(startStep, endStep + 1), //[1,2,3,4,5]
        claimProgressStartStep: startStep,
        claimProgressEndStep: endStep
    }
}

// initiallized Data
const CLAIM_INIT_DATA=  () => {
    return {
        claimType: "",
        claimProgress: CLAIM_PROGRESS_INIT_DATA(1, 5),
        claimProcess: 0,
        /** 원청구 **/
        claimNumberForm: {
            startDt: "",
            endDt: moment().format('YYYYMMDD'),
            claimTypeCd: "",
            searchDtType: "all",
            limit: 10,
            radioVal: ''
        },

        /** 개인정보 **/
        informationForm: {
            insurantNm: "", /* 피보험자명 */
            mbrNm: "",      /* 청구인명 */
            mbrNo: "",      /*피보험자 식별번호*/
            idNo: "",       /**/
            regNo1: "",     /*주민번호 앞*/
            regNo2: "",     /*주민번호 뒤*/
            mpno: "",       /*핸드폰번호*/
            email: "",      /*이메일*/
            rnAddr: "",     /*주소*/
            detailAddr: "", /*상세주소*/
            zip: "",        /*우펴번호*/
            identificationYn: false, /* 주민등록번호 검증여부 */
            sex: ""
        },

        /** 보험사선택 **/
        insuranceCompanyForm: {
            insuContractsList: [],
            inco_choise_list: [],
            inco_choise_info_list: [],
            agree_terms_complete: false,
            insuAgreeForm: [],
            incoTerms: [],
            inco_choise_all:false,
            incoIdntfCd: "",
            insttNm: "",
        },

        /** 병원선택 **/
        hospitalForm: {
            hospitalCd: "",
            insttNm: "",
        },

        /** 진료내역선택 **/
        mtrtListForm: {
            searchMtrtDtType: "3y",
            searchStartMtrtDt: "",
            searchEndMtrtDt: "",
            searchIopatientCls: "",
            mtrtSlcList: [],
            mtrtCnt: "",
            mdcost: 0,
            mtrtList: [],
            incoTreats: [],
            iopatientCls: '',
            pharmaceuticalYn: '',
            mrtrAddListCnt: 10
        },

        /** 자녀 청구정보 입력 **/
        claimChildForm: {
            mbrNo: 0,
            mbrNm: "",            /* 친권자명 */
            birthday: "",
            aprvStcd: "",        /* 승인상태코드 */
            aprvStNm: "",        /* 승인상태코드명 */
            childClsCd: "",      /* 자녀분류코드 */
            childClsNm: "",      /* 자녀분류코드명 */
            childMbrNo: "",
            childBirthday: "",
            childIdcardRegVal: "",
            childNm: "",
            childSeq: "",
            childSex: "",
            addFiles: "",
            rejectReasonCont: "",
            sex: "",
            childCustodyCd:"",
            childCustodyTerms: [],
            ciVal:"",
            qrycFg:"",
            qrycNm:"",
            myDataFlag: "",
            chidlSelectFlag: "myData"
        },
        /** 대리 청구정보 입력 **/
        claimDeputyForm: {
            mbrNo: 0,
            claimTargetSeq: "",
            deputyRelCd: "",            /* 대리관계코드 */
            deputyRelNm: "",            /* 대리관계코드명 */
            claimTrgterid: "",
            claimTrgterNm: "",
            claimTrgterMpno: "",
            claimTrgterBirthday: "",
            mbrNm: "",
            mbrMpno: "",
            mpno: "",
            deputyClaimTargetMbrNo: "",
            birthdaySex: "",
            deputyClaimStcd: "",
            deputyClaimStcdNm: "",
            birthday: "",
            idcardRegVal: "",    /* 신분증등록값(주민) */
            tempKey: "", /* 알림톡 연계용 임시키 */
            proxyAgreeList: [],
            proxyAgreeCheckList: [],
            claimId: "",
            isAgree: ""
        },

        /** 청구정보 입력 **/
        claimForm: {
            acdntCont: "",
            acdntDt: new Date(),
            acdntDate: "",
            acdntDtHour: "",
            acdntDtMinute: "",
            acrndNo: 0,
            acdntPlace: "",
            acdntPlaceAddr: "",
            acdntPlaceZip: "",
            acdntPlaceDetailAddr: "",
            acdntType: "",
            clmntNm: "",
            clmntMpno: "",
            claimTypeArray: [],
            zip: "",
            guideMpno: "",
            guideEmail: "",
            transMediaKind: "",
            mdcareRecipterYn: "",
            benfcryRelCd: "",
            prescriptionReceipts: "",
            phoneType: "0",
            insuDivision: {
                hospitalizationYn: false,
                ambulatoryCareYn: false,
                surgeryYn: false,
                diagnoseYn: false,
                obstacleYn: false,
                passingYn: false
            },
            insuDivisionChkList: [],
            notifierName: "",
            guideAddr: "",
            guideDetailAddr: "",
            guideZip: "",
            authPhoneFlag: false,
            authPhone: "",
            newClaimYn: false,
            personalAgreeTermsNo : []
        },

        /** 지급계좌 **/
        bankAccntForm: {
            bankAccntHolderYn: false,
            bankAccntAddYn: false,
            eltrAccntYn: [],
            dpstr: "",
            dpstrCd: "",
            dpstrNm: "",
            dpstrRelCd: "",
            bankCd: "",
            bankNm: "",
            bankNmAbbr: "",
            bankAccnt: "",
            bankKind: "",
            accntMngNo: "",
            openbankingKey: "",
            selfAcctYn: true,
            dpstrBirthday: "",
            touchEnSolution: "",
            hidKeyData: "",
            tnkSr: "",
            e2ePassword: "",
            id: "",
            transkey: "",
            transkeyHM: "",
            keyboardType: "",
            keyIndex: "",
            fieldType: "",
            seedKey: "",
            initTime: "",
            rsaEncryptedPacket: "",
            touchEnSolutionType: "NX_KEY",
            transObj: {
                touchEnSolution: "",
                hidKeyData: "",
                tnkSr: "",
                e2ePassword: "",
                id: "",
                transkey: "",
                transkeyHM: "",
                keyboardType: "",
                keyIndex: "",
                fieldType: "",
                seedKey: "",
                initTime: "",
                rsaEncryptedPacket: "",
                touchEnSolutionType: "NX_KEY",
            }
        },

        iconUrl: "",
        address: "",
        addressDetail: "",
        addFiles: [],
        fileKey: "",
        sign: "",
        agree_Stcd: "",
        acrndNos:"",

    }
}

export const useClaimStore = defineStore(
    "useClaimStore",
    () => {
        const claim = ref({});
        const init = () => {
            // claim.value = claimObj;
            // claim.value = CLAIM_INIT_DATA();
            Object.assign(claim.value, CLAIM_INIT_DATA());
        }


        const setItem = (value) => {
            commonJs.deepUpdate(claim.value, value);
        }

        const forItem = (checkObj, item) => {

            for (let i in item) {
                if (typeof (item[i]) === 'object' && Object.keys(item[i]).length > 1) {
                    forItem(checkObj[i], item[i])
                } else {
                    checkObj[i] = item[i];
                }
            }
        }

        const progressInit = (start, end) => {
            claim.value.claimProgress = CLAIM_PROGRESS_INIT_DATA(start, end);

        }

        const step = (step, inc, decrement) => {
            switch (step) {
                case "prev":
                        claim.value.claimProgress.claimProgressCurrentStep -= 1;
                        if (inc) {
                            if(claim.value.claimProgress.claimProgressEndStep > 5){
                                claim.value.claimProgress.claimProgressEndStep -= inc;
                                claim.value.claimProgress.claimProgressTotalStep = _.range(claim.value.claimProgress.claimProgressStartStep, claim.value.claimProgress.claimProgressEndStep + 1)
                            }
                        }
                    break;

                case "next":
                        claim.value.claimProgress.claimProgressCurrentStep += 1;
                        if (inc) {
                            if(claim.value.claimProgress.claimProgressEndStep < 6){
                                claim.value.claimProgress.claimProgressEndStep += inc;
                                claim.value.claimProgress.claimProgressTotalStep = _.range(claim.value.claimProgress.claimProgressStartStep, claim.value.claimProgress.claimProgressEndStep + 1)

                            }else if(decrement){
                                claim.value.claimProgress.claimProgressEndStep -= inc;
                                claim.value.claimProgress.claimProgressTotalStep = _.range(claim.value.claimProgress.claimProgressStartStep, claim.value.claimProgress.claimProgressEndStep + 1)
                            }
                        }
                    break;
            }
        }
        const isAddFile = () => {
            return claim.value.insuranceCompanyForm.inco_choise_info_list.filter(item => item.addFileYn === 'Y').length > 0 ||
                claim.value.mtrtListForm.pharmaceuticalYn === "Y"
        }

        const processLevel = (level) => {
            if (claim.value.claimForm.newClaimYn) {
                if (isAddFile()) {
                    if (level >= 7) {
                        return level - 3;
                    } else if (level >= 3) {
                        return level - 1;
                    } else {
                        return level;
                    }
                } else {
                    if (level >= 7) {
                        return level - 4;
                    } else if (level >= 3) {
                        return level - 1;
                    } else {
                        return level;
                    }
                }
            } else {
                if (isAddFile()) {
                    return level;
                } else {
                    if (level >= 7) {
                        return level - 1;
                    } else {
                        return level;
                    }

                }
            }
        }

        const isDevelopment = () => {
            return process.env.VUE_APP_ENV == 'development'
        }

        const getStep = (step, target) => {
            const getAddFileCheckStep = (step, target) => {
                if (claim.value.insuranceCompanyForm.inco_choise_info_list.filter(item => item.addFileYn === 'Y').length > 0 ||
                    claim.value.mtrtListForm.pharmaceuticalYn === "Y"
                ) {
                    if (commonJs.isEmpty(target) && step >= 5) {
                        if (claim.value.claimForm.newClaimYn) {
                            return step - 2;
                        } else {
                            return step;
                        }
                    } else if (!commonJs.isEmpty(target) && target === 'max') {
                        if (claim.value.claimForm.newClaimYn) {
                            return [1, 2, 3, 4]
                        } else {
                            return [1, 2, 3, 4, 5, 6]
                        }
                    } else {
                        return step
                    }
                } else {
                    if (commonJs.isEmpty(target) && step > 5) {
                        /* 첨부파일 제외이며 최종화면이면 첨부파일제외만큼 현제 스텝 차감 */

                        if (claim.value.claimForm.newClaimYn) {
                            return step - 3;
                        } else {
                            return step - 1;
                        }
                    } else if (!commonJs.isEmpty(target) && target === 'max') {
                        if (claim.value.claimForm.newClaimYn) {
                            return [1, 2, 3]
                        } else {
                            return [1, 2, 3, 4, 5]
                        }
                    } else {
                        return step
                    }
                }
            }
            // return

            if (commonJs.isEmpty(target) || target !== 'max') {
                return getAddFileCheckStep(step)

            } else if (target === 'max') {
                return getAddFileCheckStep(step, target)
            }

            // if (calim.value.claimForm.newClaimYn){
            //     else if (target === 'maxArray'){
            //         return [1,2,3]
            //     }
            // } else {
            //     if(target === 'currentStep'){
            //         return getAddFileCheckStep(step)
            //     }else if (target === 'maxArray'){
            //         return [1,2,3,4,5]
            //     }
            // }
        }

        const getClaimTypeName = () => {
            switch (claim.value.claimType) {
                case "1" :
                    return "나의 실손청구"
                    break;
                case "2" :
                    return "나의 자녀청구"
                    break;
                case "3" :
                    return "나의부모/제3자 청구"
                    break;
            }
        }

        return {claim, init, setItem, progressInit, getStep, processLevel, isDevelopment, getClaimTypeName}
    },
    {
        persist: {
            storage: sessionStorage
        }
    }
)